import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X, ChevronDown } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [servicesOpen, setServicesOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const services = [
    { name: 'Web Development', path: '/services/web-development' },
    { name: 'SaaS Development', path: '/services/saas-development' },
    { name: 'Custom Software', path: '/services/custom-software' },
    { name: 'UI/UX Engineering', path: '/services/ui-ux-engineering' },
    { name: 'AI & Automation', path: '/services/ai-automation' },
    { name: 'ERP Solutions', path: '/services/erp-solutions' },
    { name: 'Odoo Implementation', path: '/services/odoo-implementation' },
    { name: 'Odoo Customization', path: '/services/odoo-customization' },
    { name: 'Odoo Migration', path: '/services/odoo-migration' },
    { name: 'Odoo Support', path: '/services/odoo-support' },
    { name: '30 Days Support', path: '/services/customer-support' },
  ]

  return (
    <nav 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'glass-panel shadow-lg' : 'bg-transparent'
      }`}
      data-component-path="client/src/components/Navbar.jsx"
      data-component-line="1:1"
      data-component-id="client/src/components/Navbar.jsx:1:1"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="2:3" data-component-id="client/src/components/Navbar.jsx:2:3">
        <div className="flex justify-between items-center h-20" data-component-path="client/src/components/Navbar.jsx" data-component-line="3:5" data-component-id="client/src/components/Navbar.jsx:3:5">
          <Link to="/" className="flex items-center gap-3" data-component-path="client/src/components/Navbar.jsx" data-component-line="4:7" data-component-id="client/src/components/Navbar.jsx:4:7">
            <div className="w-12 h-12 bg-neon-green rounded-lg flex items-center justify-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="5:9" data-component-id="client/src/components/Navbar.jsx:5:9">
              <span className="text-dark-primary font-bold text-xl" data-component-path="client/src/components/Navbar.jsx" data-component-line="6:11" data-component-id="client/src/components/Navbar.jsx:6:11">DT</span>
            </div>
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="8:9" data-component-id="client/src/components/Navbar.jsx:8:9">
              <h1 className="text-xl font-bold text-white" data-component-path="client/src/components/Navbar.jsx" data-component-line="9:11" data-component-id="client/src/components/Navbar.jsx:9:11">The Dark Tech</h1>
              <p className="text-xs text-neon-green" data-component-path="client/src/components/Navbar.jsx" data-component-line="10:11" data-component-id="client/src/components/Navbar.jsx:10:11">Solutions</p>
            </div>
          </Link>

          <div className="hidden lg:flex items-center gap-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="15:7" data-component-id="client/src/components/Navbar.jsx:15:7">
            <Link to="/" className={`hover:text-neon-green transition-colors ${location.pathname === '/' ? 'text-neon-green' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="16:9" data-component-id="client/src/components/Navbar.jsx:16:9">
              Home
            </Link>
            <Link to="/about" className={`hover:text-neon-green transition-colors ${location.pathname === '/about' ? 'text-neon-green' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="19:9" data-component-id="client/src/components/Navbar.jsx:19:9">
              About
            </Link>
            <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="22:9" data-component-id="client/src/components/Navbar.jsx:22:9">
              <button className="flex items-center gap-1 hover:text-neon-green transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="23:11" data-component-id="client/src/components/Navbar.jsx:23:11">
                Services <ChevronDown className="w-4 h-4" data-component-path="client/src/components/Navbar.jsx" data-component-line="24:22" data-component-id="client/src/components/Navbar.jsx:24:22" />
              </button>
              <AnimatePresence>
                {servicesOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="absolute top-full left-0 mt-2 w-64 glass-panel rounded-xl p-4 shadow-xl"
                    data-component-path="client/src/components/Navbar.jsx"
                    data-component-line="31:17"
                    data-component-id="client/src/components/Navbar.jsx:31:17"
                  >
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.path}
                        className="block px-4 py-2 hover:bg-neon-green/10 hover:text-neon-green rounded-lg transition-colors"
                        data-component-path="client/src/components/Navbar.jsx"
                        data-component-line="38:21"
                        data-component-id="client/src/components/Navbar.jsx:38:21"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            <Link to="/odoo-partner" className={`hover:text-neon-green transition-colors ${location.pathname === '/odoo-partner' ? 'text-neon-green' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="50:9" data-component-id="client/src/components/Navbar.jsx:50:9">
              Odoo Partner
            </Link>
            <Link to="/portfolio" className={`hover:text-neon-green transition-colors ${location.pathname === '/portfolio' ? 'text-neon-green' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="53:9" data-component-id="client/src/components/Navbar.jsx:53:9">
              Portfolio
            </Link>
            <Link to="/blog" className={`hover:text-neon-green transition-colors ${location.pathname === '/blog' ? 'text-neon-green' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="56:9" data-component-id="client/src/components/Navbar.jsx:56:9">
              Blog
            </Link>
            <Link to="/contact" data-component-path="client/src/components/Navbar.jsx" data-component-line="59:9" data-component-id="client/src/components/Navbar.jsx:59:9">
              <button className="h-11 px-6 bg-neon-green text-dark-primary font-semibold rounded-xl hover:shadow-lg hover:shadow-neon-green/50 transition-all duration-200 flex items-center justify-center gap-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="60:11" data-component-id="client/src/components/Navbar.jsx:60:11">
                Contact Us
              </button>
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white"
            data-component-path="client/src/components/Navbar.jsx"
            data-component-line="68:7"
            data-component-id="client/src/components/Navbar.jsx:68:7"
          >
            {isOpen ? <X className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="72:24" data-component-id="client/src/components/Navbar.jsx:72:24" /> : <Menu className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="72:62" data-component-id="client/src/components/Navbar.jsx:72:62" />}
          </button>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden pb-4"
              data-component-path="client/src/components/Navbar.jsx"
              data-component-line="81:11"
              data-component-id="client/src/components/Navbar.jsx:81:11"
            >
              <div className="flex flex-col gap-4" data-component-path="client/src/components/Navbar.jsx" data-component-line="86:13" data-component-id="client/src/components/Navbar.jsx:86:13">
                <Link to="/" className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="87:15" data-component-id="client/src/components/Navbar.jsx:87:15">
                  Home
                </Link>
                <Link to="/about" className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="90:15" data-component-id="client/src/components/Navbar.jsx:90:15">
                  About
                </Link>
                <div data-component-path="client/src/components/Navbar.jsx" data-component-line="93:15" data-component-id="client/src/components/Navbar.jsx:93:15">
                  <button onClick={() => setServicesOpen(!servicesOpen)} className="flex items-center gap-1 hover:text-neon-green transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="94:17" data-component-id="client/src/components/Navbar.jsx:94:17">
                    Services <ChevronDown className={`w-4 h-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} data-component-path="client/src/components/Navbar.jsx" data-component-line="95:28" data-component-id="client/src/components/Navbar.jsx:95:28" />
                  </button>
                  {servicesOpen && (
                    <div className="ml-4 mt-2 flex flex-col gap-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="98:19" data-component-id="client/src/components/Navbar.jsx:98:19">
                      {services.map((service, index) => (
                        <Link key={index} to={service.path} className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="100:23" data-component-id="client/src/components/Navbar.jsx:100:23">
                          {service.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
                <Link to="/odoo-partner" className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="107:15" data-component-id="client/src/components/Navbar.jsx:107:15">
                  Odoo Partner
                </Link>
                <Link to="/portfolio" className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="110:15" data-component-id="client/src/components/Navbar.jsx:110:15">
                  Portfolio
                </Link>
                <Link to="/blog" className="hover:text-neon-green transition-colors" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="113:15" data-component-id="client/src/components/Navbar.jsx:113:15">
                  Blog
                </Link>
                <Link to="/contact" onClick={() => setIsOpen(false)} data-component-path="client/src/components/Navbar.jsx" data-component-line="116:15" data-component-id="client/src/components/Navbar.jsx:116:15">
                  <button className="w-full h-11 px-6 bg-neon-green text-dark-primary font-semibold rounded-xl hover:shadow-lg transition-all" data-component-path="client/src/components/Navbar.jsx" data-component-line="117:17" data-component-id="client/src/components/Navbar.jsx:117:17">
                    Contact Us
                  </button>
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  )
}

export default Navbar